import Image from 'next/image';
import React from 'react';
import cn from 'classnames';
import { CSSVars } from '../../styles/styles.config';
import { IContentPage, IContentPageFeature } from '../../types';
import { Banner } from '../banner/banner.comp';
import { Feature } from '../feature/feature.comp';
import { Section } from '../section/section.comp';
import { StyledDiv } from './contentPageFeatures.styles';
import { StyledDiv as FeatureStyledDiv } from '../feature/feature.styles';
import { CommonNinjaWidget } from 'commonninja-react';

export const ContentPageFeatures = ({
	contentPage,
}: {
	contentPage: IContentPage;
}) => {
	function renderFeature(feature: IContentPageFeature) {
		switch (feature.type) {
			case 'widget':
				return (
					<>
						<FeatureStyledDiv
							className={`full-width feature`}
							style={{
								justifyContent: 'center',
								textAlign:
									feature.position === 'top-to-bottom' ? 'center' : 'left',
							}}
						>
							<div className="content">
								<div className={`details-wrapper`}>
									<div className="wrapper">
										{feature.title && <h2>{feature.title}</h2>}
										{feature.subtitle && <h3>{feature.subtitle}</h3>}
									</div>
								</div>
							</div>
						</FeatureStyledDiv>
						<CommonNinjaWidget
							key={feature.text + ' pluginId'}
							widgetId={feature.pluginId || ''}
						/>
					</>
				);

			case 'banner':
				let buttonLink = feature.buttonPath || '';
				if (buttonLink?.startsWith('/')) {
					if (feature.buttonPath?.includes('brackets-types')) {
						buttonLink = `/types`;
					} else if (feature.buttonPath?.includes('/brackets/')) {
						buttonLink = `/types/${feature.buttonPath.split('/brackets/')[1]}`;
					} else if (feature.buttonPath?.includes('/widgets/brackets')) {
						buttonLink = `https://www.commoninja.com/brackets/editor?via=brackets`;
					} else {
						`https://www.commoninja.com${(feature.buttonPath?.[0] === '/') ? feature.buttonPath : `/${feature.buttonPath}`}?via=brackets`;
					}
				}

				return (
					<Banner
						key={feature.text + ' banner'}
						title={feature.title}
						text={feature.text}
						isHtml={true}
						bannerStyle={{
							background: '#FAFAFC',
							border: `1px solid ${CSSVars.gray200}`,
							color: '#141414',
							padding: '50px',
						}}
						style={{ padding: 0 }}
						buttonText={feature.buttonText}
						buttonLink={buttonLink}
					/>
				);

			default:
				return (
					<Feature
						key={feature.text}
						title={feature.title}
						subtitle={feature.subtitle}
						imgCaption={feature.imgCaption}
						text={feature.text}
						isHtml={true}
						position={
							feature.position === 'top-to-bottom' ? 'ttb' : feature.position
						}
						alt={feature.imgAlt}
						img={feature.imgUrl}
						linkPath={feature.buttonPath || ''}
						linkText={feature.buttonText || ''}
						openInNewWindow={feature.target === '_blank'}
						pluginId={feature.pluginId}
					/>
				);
		}
	}

	return (
		<>
			{contentPage.hero && (
				<Section style={{ paddingBottom: '0px' }}>
					<StyledDiv>
						<Image
							className="main-image"
							src={contentPage.hero}
							alt={`${contentPage.name}`}
							width={930}
							height={520}
						/>
					</StyledDiv>
				</Section>
			)}
			{contentPage.features.length > 0 && (
				<Section>
					<StyledDiv>
						<div
							className={cn('features-container', contentPage.slug, {
								'full-width': contentPage.isFullPage,
							})}
						>
							{contentPage.features.map((feature) => renderFeature(feature))}
						</div>
					</StyledDiv>
				</Section>
			)}
		</>
	);
};
